import { Scheduling, OccupationInfo } from '@src/core/buyerApiClient';

export const schedulingContainsMinute = (scheduling: Scheduling, minute: number) =>
  scheduling.availableScheduleTimes?.some((st) => st.minutes === minute);

const occupationIsAvailable = (occupation: OccupationInfo) =>
  occupation.availableAmount === null || occupation.availableAmount > 0;

export const schedulingHasAvailableOccupation = (scheduling: Scheduling): boolean => {
  if (scheduling.occupationRates.quantity) {
    return !!scheduling.occupationRates.tariffQuantities?.some((tq) => occupationIsAvailable(tq.occupation));
  }

  if (scheduling.occupationRates.scheduleQuantities) {
    return !!scheduling.occupationRates.tariffScheduleQuantities?.some((tsq) =>
      tsq.occupationSchedule.some((os) => occupationIsAvailable(os.occupation)),
    );
  }

  return true;
};
